// extracted by mini-css-extract-plugin
export default {"btnPos":"StripeLogoModules_btnPos__TCoGX","scrollFor":"StripeLogoModules_scrollFor__-tFzq","ant-card-actions":"StripeLogoModules_ant-card-actions__NyJU5"};